// Centralized configuration for environment variables
export const config = {
  // Base URL for API calls (without /api suffix)
  // baseUrl: process.env.REACT_APP_API_BASE_URL,
  // Base URL for API calls (with /api suffix)
  baseUrl: `${process.env.REACT_APP_API_BASE_URL}api`,
};

export default config;
